export const buildAdminBaseUri = (baseUri: string): string => {
  try {
    const url = new URL(baseUri);

    url.hostname = `admin.${url.hostname.replace(/^admin\./, '')}`;

    return url.origin;
  } catch {
    return baseUri;
  }
};
